<template>
  <router-link :to="{ name: central }">
    <Logo style="fill: white; width: 130px; vertical-align: middle;" />
  </router-link>
</template>

<script>
import Logo from '@/assets/images/openfreight.svg'
import { mapGetters } from 'vuex'

export default {
  components: {
    Logo
  },
  computed: {
    ...mapGetters({
      central: 'configuration/layout/central'
    })
  }
  // methods: {
  //   redirect () {
  //     switch (this.central) {
  //       case 'customerservice':
  //         this.$router.push({ name: 'customerservice' })
  //         break
  //       case 'manage':
  //         this.$router.push({ name: 'manage' })
  //         break
  //       case 'sales':
  //         this.$router.push({ name: 'sales' })
  //         break
  //       case 'freight':
  //         this.$router.push({ name: 'freight' })
  //         break
  //       case 'billing':
  //         this.$router.push({ name: 'billing' })
  //         break
  //       case 'reports':
  //         this.$router.push({ name: 'reports' })
  //         break
  //       case 'configuration':
  //         this.$router.push({ name: 'configuration' })
  //         break
  //       default:
  //         this.$router.push({ name: 'customerservice' })
  //         break
  //     }
  //   }
  // }
}
</script>
